"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goScenario_sync = exports.goScenario_load = exports.goScenario_generate_new_scenario = exports.goScenario_reloaded_continue_game = exports.goScenario_new = exports.goGame = exports.goBodyAlign = exports.goEditor = exports.goMenuMain = exports.goLoading = exports.update = exports.addAfterLoad = exports.networkPause = exports.togglePause = exports.get = void 0;
var common_sidecar_1 = require("@main/common-sidecar");
var voyageMessageGeneralCommand_1 = require("@voyage/multi/voyageMessageGeneralCommand");
var voyageMessageGeneralCommand_sidecar_1 = require("@voyage/multi/voyageMessageGeneralCommand-sidecar");
var diveGameMode_scenario_new_sidecar_1 = require("@voyage/gamemodes/diveGameMode_scenario_new-sidecar");
var voyageGameMode_bodyAlign_sidecar_1 = require("@voyage/gamemodes/voyageGameMode_bodyAlign-sidecar");
var voyageGameMode_editor_sidecar_1 = require("@voyage/gamemodes/voyageGameMode_editor-sidecar");
var voyageGameMode_game_sidecar_1 = require("@voyage/gamemodes/voyageGameMode_game-sidecar");
var voyageGameMode_loading_sidecar_1 = require("@voyage/gamemodes/voyageGameMode_loading-sidecar");
var voyageGameMode_menuMain_sidecar_1 = require("@voyage/gamemodes/voyageGameMode_menuMain-sidecar");
var voyageGameMode_scenario_clientSyncWorld_sidecar_1 = require("@voyage/gamemodes/voyageGameMode_scenario_clientSyncWorld-sidecar");
var voyageGameMode_scenario_load_sidecar_1 = require("@voyage/gamemodes/voyageGameMode_scenario_load-sidecar");
var voyageGameMode_scenario_new_sidecar_1 = require("@voyage/gamemodes/voyageGameMode_scenario_new-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
function togglePause() {
    voyageMessageGeneralCommand_sidecar_1.voyageMessageGeneralCommand.sendMessageAndImmediatelyExecute({
        command: get().isPaused ? voyageMessageGeneralCommand_1.EGeneralCommand.Unpause : voyageMessageGeneralCommand_1.EGeneralCommand.Pause,
    });
}
exports.togglePause = togglePause;
function networkPause(isPaused) {
    get().isPaused = isPaused;
}
exports.networkPause = networkPause;
function create() {
    var obj = {
        generator: null,
        generator_exit: null,
        generatorPauseSeconds: 0,
        isPaused: false,
        mode: 'init',
        afterLoad: [],
    };
    return obj;
}
function addAfterLoad(action) {
    var obj = get();
    obj.afterLoad.push(action);
}
exports.addAfterLoad = addAfterLoad;
function update() {
    var obj = get();
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    if (obj.generatorPauseSeconds > 0) {
        obj.generatorPauseSeconds -= ds;
        return;
    }
    if (obj.generator) {
        var generatorResult = obj.generator.next();
        if (generatorResult.done) {
            // console.log('voyageGameManager', 'Generator is done!')
            // obj.generator = null
        }
        else {
            obj.generatorPauseSeconds = generatorResult.value;
        }
    }
}
exports.update = update;
function switchMode(newMode, generator, generatorExit) {
    if (generatorExit === void 0) { generatorExit = function () { }; }
    var obj = get();
    exitCurrentMode();
    obj.mode = newMode;
    obj.generator = generator;
    obj.generator_exit = generatorExit;
}
function exitCurrentMode() {
    var obj = get();
    if (obj.generator_exit) {
        obj.generator_exit();
        obj.generator_exit = null;
    }
}
function goLoading() {
    switchMode('loading', voyageGameMode_loading_sidecar_1.voyageGameMode_loading.generator_loading());
}
exports.goLoading = goLoading;
function goMenuMain() {
    switchMode('main-menu', voyageGameMode_menuMain_sidecar_1.voyageGameMode_menuMain.generator_menuMain());
}
exports.goMenuMain = goMenuMain;
function goEditor() {
    switchMode('editor', voyageGameMode_editor_sidecar_1.voyageGameMode_editor.generator_editor());
}
exports.goEditor = goEditor;
function goBodyAlign() {
    switchMode('body-align', voyageGameMode_bodyAlign_sidecar_1.voyageGameMode_bodyAlign.generator_bodyAlign());
}
exports.goBodyAlign = goBodyAlign;
function goGame() {
    switchMode('game', voyageGameMode_game_sidecar_1.voyageGameMode_game.generator_game());
}
exports.goGame = goGame;
function goScenario_new() {
    switchMode('scenario', voyageGameMode_scenario_new_sidecar_1.voyageGameMode_scenario_new.generator_newScenario_oldVoyage());
}
exports.goScenario_new = goScenario_new;
function goScenario_reloaded_continue_game() {
    switchMode('scenario', diveGameMode_scenario_new_sidecar_1.diveGameMode_scenario_new.generator_newScenario(true), function () {
        // console.log('resetting camera')
        // voyageCamera.setCameraXY(300, 600)
        // voyageCamera.setZoom(0.25)
    });
}
exports.goScenario_reloaded_continue_game = goScenario_reloaded_continue_game;
function goScenario_generate_new_scenario() {
    switchMode('scenario', diveGameMode_scenario_new_sidecar_1.diveGameMode_scenario_new.generator_newScenario(false), function () {
        // console.log('resetting camera')
        // voyageCamera.setCameraXY(300, 600)
        // voyageCamera.setZoom(0.25)
    });
}
exports.goScenario_generate_new_scenario = goScenario_generate_new_scenario;
function goScenario_load() {
    switchMode('scenario', voyageGameMode_scenario_load_sidecar_1.voyageGameMode_scenario_load.generator_loadScenario(function () { }), function () { });
}
exports.goScenario_load = goScenario_load;
function goScenario_sync() {
    switchMode('scenario', voyageGameMode_scenario_clientSyncWorld_sidecar_1.voyageGameMode_scenario_clientSyncWorld.generator_clientSyncWorld());
}
exports.goScenario_sync = goScenario_sync;
// export function goScenario_crokinole() {
//   switchMode(
//     'scenario',
//     voyageGameMode_scenario_crokinole.generator_crokinole(),
//   )
// }
